import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined'
import CallOutlinedIcon from '@mui/icons-material/CallOutlined'
import MailOutlinedIcon from '@mui/icons-material/MailOutlined'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import { useRouter } from 'next/router'
import { useContext, useState, useEffect } from 'react'
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar'
import { logOutHandler } from '@/utils/functions'
import { useRef } from 'react'
import { SharedContext } from '@/context/SharedContext'
import { SeekerContext } from '@/context/SeekerContext'

function SeekerHeader({ setShowToast, setShowMenu }) {
  const [copied, setCopied] = useState(false)
  const { loginDetails, setLoginDetails, cookie } = useContext(SharedContext)

  const { setLogInOpen, isJobProfileCreated } = useContext(SeekerContext)

  const router = useRouter()
  const iconStyles = {
    width: '24px',
    height: '24px',
    color: '#989898'
  }
  let helpItems = [
    {
      id: 1,
      title: 'Email us at',
      copyText: 'Email address',
      subText: 'jobssupport@getlokalapp.com',
      footer: '',
      icon: <MailOutlinedIcon style={iconStyles} />,
      link: 'mailto:jobssupport@getlokalapp.com'
    }
  ]
  let menuItems = [
    {
      id: 1,
      name: isJobProfileCreated ? 'My profile' : 'Create profile',
      icon: <AccountCircleOutlinedIcon sx={iconStyles} />,
      link: '/create_profile'
    },
    {
      id: 2,
      name: loginDetails.isLogIn ? 'Log out' : 'Log in',
      icon: <LogoutOutlinedIcon sx={iconStyles} />
    },
    {
      id: 4,
      name: 'Search jobs',
      icon: <SearchOutlinedIcon sx={iconStyles} />,
      link: '/jobs/jobs-near-me'
    },
    {
      id: 5,
      name: 'Looking to Hire?',
      icon: <BusinessCenterOutlinedIcon sx={iconStyles} />,
      link: '/hire'
    },
    {
      id: 6,
      name: 'Download app',
      icon: <FileDownloadOutlinedIcon sx={iconStyles} />,
      link: 'https://play.google.com/store/apps/details?id=get.lokal.localjobs&hl=en_IN'
    }
  ]
  const handleCopy = async (text, title) => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setShowToast((p) => {
        return {
          ...p,
          status: !p.status,
          text: title
        }
      })
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }
  return (
    <div
      id="seeker-header"
      className="fixed top-[52px] z-20 w-[95%] rounded-b-[16px] border-solid bg-white"
    >
      <ul id="menu-items" className="mt-[36px] p-[0]">
        {menuItems.map((item, id) => {
          if (item.id === 2 && item.name == 'Log in') {
            return (
              <li
                className="flex items-center gap-[12px] p-[12px] font-noto-sans text-[14px] font-[400] text-greyTitleBase900"
                key={id}
                onClick={() => {
                  setShowMenu(false)

                  setLogInOpen(true)
                }}
              >
                {item.icon}
                {item.name}
              </li>
            )
          } else if (item.name === 'Log out') {
            return (
              <li
                className="flex items-center gap-[12px] p-[12px] font-noto-sans text-[14px] font-[400] text-greyTitleBase900"
                key={id}
                onClick={async () => {
                  if (item?.link) router.push(item.link)

                  await logOutHandler({ setLoginDetails: setLoginDetails, loginDetails, cookie })
                  setShowMenu(false)
                  setLogInOpen(false)
                }}
              >
                {item.icon}
                {item.name}
              </li>
            )
          } else if (item.id === 1) {
            return (
              loginDetails?.isLogIn && (
                <li
                  className="flex items-center gap-[12px] p-[12px] font-noto-sans text-[14px] font-[400] text-greyTitleBase900"
                  key={id}
                  onClick={() => {
                    if (item?.link) router.push(item.link)
                  }}
                >
                  {item.icon}
                  {item.name}
                </li>
              )
            )
          } else {
            return (
              <li
                key={id}
                className="flex items-center gap-[12px] p-[12px] font-noto-sans text-[14px] font-[400] text-greyTitleBase900"
                onClick={() => {
                  if (item?.link) router.push(item.link)
                }}
              >
                {item.icon}
                {item.name}
              </li>
            )
          }
        })}
      </ul>
      <div id="help" className="custom-gradient-help rounded-b-[24px] p-[16px]">
        <div className="text-[14px] font-[600] text-greyTitleBase900">Need help?</div>
        <ul id="help-items" className="p-[0px]">
          {helpItems.map((item, id) => {
            return (
              <li
                className="flex items-center justify-between gap-[12px] rounded-[12px] font-noto-sans text-[14px] font-[400] text-greyTitleBase900"
                key={id}
              >
                <div className="mt-[14px] flex space-x-[12px]">
                  <div
                    id="icon"
                    className="border-x-greyDisabledBackground50 rounded-[12px] p-[8px]"
                  >
                    {item.icon}
                  </div>
                  <div id="content" className="flex flex-col space-y-[4px]">
                    <div>
                      {' '}
                      <a href={item.link} className="text-greyTitleBase900 no-underline">
                        {item.title}
                      </a>
                    </div>{' '}
                    <div>
                      {' '}
                      <a href={item.link} className="text-blueSecondary500 no-underline">
                        {item.subText}
                      </a>
                    </div>
                    <div> {item.footer}</div>
                  </div>
                </div>

                <div
                  id="copy"
                  onClick={() => {
                    handleCopy(item.subText, item.copyText)
                  }}
                >
                  <ContentCopyOutlinedIcon style={iconStyles} />
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default SeekerHeader
